module.exports = __webpack_public_path__ + "static/media/brand_black_regular.fb63fe57.png";